import { render, staticRenderFns } from "./frameView.vue?vue&type=template&id=81238400&"
import script from "./frameView.vue?vue&type=script&lang=js&"
export * from "./frameView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports